module.exports = __webpack_public_path__ + "img/1 (45).a49e026b.png";